import React from "react"
import {
    Container,
    Col,
    Row,
    UncontrolledTooltip,
    Badge
  } from 'reactstrap';
import Database from "./Database"
import CountryDetails from './CountryDetails'
import { Emoji } from 'emoji-mart'
import Header from "./Header"
import worldmap from "./images/worldmap.svg"
import universalsuffrage from "./images/universalsuffrage.png"
import electronicvoting from "./images/electronicvoting.png"
import agevote from "./images/agevote.png"
import prisoners from "./images/prisoners.png"
import currentleader from "./images/currentleader.png"
import nigeriaspeaksimg from "./images/nigeriaspeaks.jpg"
import howoften from "./images/howoften.png"
import ReactSVG from 'react-svg'
import TweetEmbed from 'react-tweet-embed'
import speaks from "./images/speaks.jpg"
import speakimage from "./images/speakimage.jpg"
// import { FacebookProvider, Group } from 'react-facebook';



class IntroSelect extends React.Component{
    constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
        this.state = {
          value:'Nigeria',
          isoval:"NG"
        };
      }
    
      handleChange(event) {
        this.setState({value: event.target.value});
      }
    
      render() {


        const AllCountries = Database.map(function(data){
                return(
                    <option key={data.ID} value={data.CountryName}>{data.CountryName}</option>
                )
            })

        const ValidCountries = Database.filter(function(data){
            return(
                data.VotingIn2019 !== "NA"
            )
        })

        function LeadershipTerm(dmin,dmax){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.LeadershipTerm > dmin) && (data.LeadershipTerm <= dmax) 
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvala="ida"+data.ID;
                return(
                    <span id={idvala}>
                    <Emoji emoji={isoval} size={28} />
                    <UncontrolledTooltip placement="top" target={idvala}>
                    {data.CountryName}
                    </UncontrolledTooltip>
                </span>
                )
            })
            return datum;
        }

        function MaxLeadershipTerm(dmin,dmax){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.MaximumTerms > dmin) && (data.MaximumTerms <= dmax || data.MaximumTerms === "Unlimited")
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvalb="idb"+data.ID;
                return(
                    <span id={idvalb}>
                    <Emoji emoji={isoval} size={28} />
                    <UncontrolledTooltip placement="top" target={idvalb}>
                    {data.CountryName}
                    </UncontrolledTooltip>
                </span>
                )
            })
            return datum;
        }

        function CurrentLeadership(dmin,dmax){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.CurrentLeaderYearsInPower > dmin) && (data.CurrentLeaderYearsInPower <= dmax)
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvalc="idc"+data.ID;
                return(
                    <span id={idvalc}>
                        <Emoji emoji={isoval} size={28} />
                        <UncontrolledTooltip placement="top" target={idvalc}>
                        {data.CountryName} 
                        </UncontrolledTooltip>
                    </span>
                )
            })
            return datum;
        }

        function PrisonersVote(status){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.PrisonersCanVote === status)
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvald="idd"+data.ID;
                return(
                    <span id={idvald}>
                        <Emoji emoji={isoval} size={28} />
                        <UncontrolledTooltip placement="top" target={idvald}>
                        {data.CountryName} 
                        </UncontrolledTooltip>
                    </span>
                )
            })
            return datum;
        }


        function UniversalSuffrage(dmin,dmax){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.WhenWomenCouldVote > dmin) && (data.WhenWomenCouldVote <= dmax)
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvale="ide"+data.ID;
                return(
                    <span id={idvale}>
                        <Emoji emoji={isoval} size={28} />
                        <UncontrolledTooltip placement="top" target={idvale}>
                        {data.CountryName} 
                        </UncontrolledTooltip>
                    </span>
                )
            })
            return datum;
        }


        function VotingAge(age){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.VotingAge === age)
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvalf="idf"+data.ID;
                return(
                    <span id={idvalf}>
                        <Emoji emoji={isoval} size={28} />
                        <UncontrolledTooltip placement="top" target={idvalf}>
                        {data.CountryName} 
                        </UncontrolledTooltip>
                    </span>
                )
            })
            return datum;
        }

        function ElectronicVoting(status){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.ElectronicVoting === status)
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvalg="idg"+data.ID;
                return(
                    <span id={idvalg}>
                        <Emoji emoji={isoval} size={28} />
                        <UncontrolledTooltip placement="top" target={idvalg}>
                        {data.CountryName} 
                        </UncontrolledTooltip>
                    </span>
                )
            })
            return datum;
        }

        let lt11 = LeadershipTerm(0,1).length
        let lt12 = LeadershipTerm(1,2).length
        let lt23 = LeadershipTerm(2,3).length
        let lt34 = LeadershipTerm(3,4).length
        let lt45 = LeadershipTerm(4,5).length
        let lt56 = LeadershipTerm(5,6).length
        let lt67 = LeadershipTerm(6,7).length
        let lt7100 = LeadershipTerm(7,1000).length

        let mlt12 = MaxLeadershipTerm(0,1).length
        let mlt23 = MaxLeadershipTerm(1,2).length
        let mlt34 = MaxLeadershipTerm(3,4).length
        let mlt10100 = MaxLeadershipTerm(10,1000).length

        let cl01 = CurrentLeadership(0,1).length
        let cl14 = CurrentLeadership(1,4).length
        let cl59 = CurrentLeadership(5,9).length
        let cl1019 = CurrentLeadership(10,19).length
        let cl2030 = CurrentLeadership(20,30).length
        let cl30100 = CurrentLeadership(30,100).length

        let pv1 = PrisonersVote("YES").length
        let pv2 = PrisonersVote("PARTIAL").length
        let pv3 = PrisonersVote("NO").length
    
        let us1 = UniversalSuffrage(1890,1900).length
        let us2 = UniversalSuffrage(1900,1910).length
        let us3 = UniversalSuffrage(1910,1920).length
        let us4 = UniversalSuffrage(1920,1930).length
        let us5 = UniversalSuffrage(1930,1940).length
        let us6 = UniversalSuffrage(1940,1950).length
        let us7 = UniversalSuffrage(1950,1960).length
        let us8 = UniversalSuffrage(1960,1970).length
        let us9 = UniversalSuffrage(1970,1980).length
        let us10 = UniversalSuffrage(1980,1990).length
        let us11 = UniversalSuffrage(1990,2000).length
        let us12 = UniversalSuffrage(2000,2010).length

        let vo16 = VotingAge(16).length
        let vo17 = VotingAge(17).length
        let vo18 = VotingAge(18).length
        let vo19 = VotingAge(19).length
        let vo20 = VotingAge(20).length
        let vo21 = VotingAge(21).length

        let ev1 = ElectronicVoting("YES").length
        let ev2 = ElectronicVoting("PARTIAL").length
        let ev3 = ElectronicVoting("NO").length


        function ElectronicVoting(status){
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.ElectronicVoting === status)
                )
            }).map(function(data){
                let isoval=':flag-'+data.ISO.toLowerCase()+':';
                let idvalg="idg"+data.ID;
                return(
                    <span id={idvalg}>
                        <Emoji emoji={isoval} size={28} />
                        <UncontrolledTooltip placement="top" target={idvalg}>
                        {data.CountryName} 
                        </UncontrolledTooltip>
                    </span>
                )
            })
            return datum;
        }

        function clearsvg(){
            let allsvg=["AF","AL","AO","AE","AR","AM","AU","AT","AZ","BI","BE","BJ","BF","BD","BG","BA","BY","BZ","BO","BR","BN","BT","BW","CF","CA","CH","CL","CN","CI","CM","CD","CG","CO","CR","CU","CZ","DE","DJ","DK","DO","DZ","EC","EG","ER","EE","ET","FI","FJ","GA","GB","GE","GH","GN","GM","GW","GQ","GR","GL","GT","GY","HN","HR","HT","HU","ID","IN","IE","IR","IQ","IS","IL","IT","JM","JO","JP","KZ","KE","KG","KH","KR","KW","LA","LB","LR","LY","LK","LS","LT","LU","LV","MA","MD","MG","MX","MK","ML","MM","ME","MN","MZ","MR","MW","MY","NA","NE","NG","NI","NL","NO","NP","NZ","OM","PK","PA","PE","PH","PG","PL","KP","PT","PY","PS","QA","RO","RU","RW","EH","SA","SD","SS","SN","SL","SV","RS","SR","SK","SI","SE","SZ","SY","TD","TG","TH","TJ","TM","TL","TN","TR","TW","TZ","UG","UA","UY","US","UZ","VE","VN","VU","YE","ZA","ZM","ZW","SO","GF","FR","ES","AW","AI","AD","AG","BS","BM","BB","KM","CV","KY","DM","FK","FO","GD","HK","KN","LC","LI","MV","MT","MS","MU","NC","NR","PN","PR","PF","SG","SB","ST","SX","SC","TC","TO","TT","VC","VG","VI","CY","RE","YT","MQ","GP","CW","IC"]
            let datum = allsvg.map(function(data){
                let beans=""
                if (document.getElementById(data) !== null){
                    let beans = document.getElementById(data).setAttribute("style","fill:#f2f2f2")
                }
                return(
                        beans
                )
            })
            return datum;
        }


        function general(){
            clearsvg()
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.GeneralElections === true)
                )
            }).map(function(data){
                let dname=data.ISO;
                let beans=""
                if (document.getElementById(dname) !== null){
                    let beans = document.getElementById(dname).setAttribute("style","fill:#cc6733")
                }
                return(
                        beans
                )
            })
            return datum;
        }

        function parliamentary(){
            clearsvg()
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.ParliamentaryElections === true)
                )
            }).map(function(data){
                let dname=data.ISO;
                let beans=""
                if (document.getElementById(dname) !== null){
                    let beans = document.getElementById(dname).setAttribute("style","fill:#996666")
                }
                return(
                        beans
                )
            })
            return datum;
        }


        function presidential(){
            clearsvg()
            let datum = ValidCountries.filter(function(data){
                return(
                    (data.PresidentialElections === true)
                )
            }).map(function(data){
                let dname=data.ISO;
                let beans=""
                if (document.getElementById(dname) !== null){
                    let beans = document.getElementById(dname).setAttribute("style","fill:#ff9900")
                }
                return(
                        beans
                )
            })
            return datum;
        }
        

        let nigeriaspeakscss={display:"none"}

        if (this.state.value === "Nigeria"){
            nigeriaspeakscss={display:"block"}
        }
        else{
            nigeriaspeakscss={display:"none"}
        }


        return (
            <div>
            <Header/>
            <Container>
            <Row>
            <Col className="text-left">
            <br/>
            <br/>
            <h2 id="howvote" className="display-3 text-center">Voting at a glance</h2>
            <br/>
            <div className="text-center">
            <p className="text-center">Select a country</p>
            <form>
            <label>
            <select className="selectstyle" onChange={this.handleChange} value={this.state.value}>
            {AllCountries}
            </select>
            </label>
            </form>
            <CountryDetails countryselected={this.state.value}/>
            </div>
            </Col>
            </Row>
            </Container>
            <Container style={nigeriaspeakscss}>
            <Row>
                <Col className="text-left">
                    <br/>
                    <br/>
                    <h2 id="howvote" className="display-3 text-center">#NigeriaSpeaks</h2>
                    <br/>
                    <img className="text-center" alt="Nigeria Speaks" width="100%" height="auto" src={nigeriaspeaksimg}/>
                    <br/>
                </Col>
            </Row>
            <br/>
            <Row>
            <Col xs="12" sm="6" className="text-center">
            <TweetEmbed id='1095330924412035077' />
            </Col>
            <Col xs="12" sm="6" className="text-center">
            <TweetEmbed id='1095625433318678528' />
            </Col>
            
            {/* <FacebookProvider appId="123456789">
        <Group
          href="https://www.facebook.com/groups/nigeriaspeaks"
          width="300"
          showSocialContext={true}
          showMetaData={true}
          skin="light"
        />
      </FacebookProvider>     */}
            </Row>
            <Row>
            <Col className="center">
            <br/>
                    <h3 className="center"> Follow our special <a href="https://www.facebook.com/groups/NigeriaSpeaks/" target="_blank">#NigeriaSpeaks</a> coverage on Facebook:</h3>
                    <br/>
            </Col>
            </Row>
            <Row>
            <Col xs="12" sm="6" className="center">
                    <a href="https://www.facebook.com/groups/NigeriaSpeaks/" target="_blank"><img className="text-center" alt="Nigeria Speaks" width="100%" height="auto" src={speaks}/></a>
            </Col>
            <Col xs="12" sm="6" className="center">
                    <a href="https://facebook.com/aljazeera/photos/a.10150243828793690/10157397218603690/?type=3&theater" target="_blank"><img className="text-center" alt="Nigeria Speaks" width="100%" height="auto" src={speakimage}/></a>
            </Col>
            </Row>
            <br/>
            <br/>
        </Container>
        <div>
        <Header/>
        <br/>
        <br/>
        <Container fluid>
            <Row>
            <Col className="text-left">
        <h2 className="display-3 text-center">Elections around the world</h2>
        <br/>
        <Container>
        <Row>
        <Col className="text-left">
        {/* <p>Short blurb goes here Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat.</p> */}
        <br/>
        </Col>
        </Row>
        </Container>

        <ReactSVG
        src={worldmap}
        svgClassName="Countries around the world"
        onInjected={(error, svg) => {
            if (error) {
              console.error(error)
              return
            }
            presidential()
          }}
        />
        <br/>
        <Container fluid>
        <Row>
        <Col className="text-center">
        <Badge className="bigger" onClick={presidential} style={{"backgroundColor":"#ff9900"}}>Presidential elections</Badge> 
        <Badge className="bigger" onClick={parliamentary} style={{"backgroundColor":"#996666"}}>Parliamentary elections</Badge>
        <Badge className="bigger" onClick={general} style={{"backgroundColor":"#cc6733"}}>General elections</Badge>
        </Col>
        </Row>
        </Container>
        <br/>
        <br/>
        </Col>
        </Row>
        </Container>
        <br/>

        <Header/>

        </div>


<Container>
    <Row>
    <Col className="text-left">
    <br/>
    <br/>
    <Container>
        <Row>
            <Col className="text-center">
            <br/>
            <img className="text-center" alt="Al Jazeera" width="200px" height="auto" src={agevote}/>
            </Col>
        </Row>
    </Container>
    
    <h2 className="display-3 text-center">How old must you be to vote?</h2>
    <br/>
    <p>Ninety percent of the world votes at age 18. If you’re 16, you’d be eligible to vote in 7 countries. You'll need to be at least 21 to vote in Lebanon, Malaysia, Samoa, Singapore and Tonga.</p>
    <br/>
    <p className="smalltext">HOVER/TAP FOR COUNTRY NAMES</p>
    <br/>
    <h3 className="stem">16: </h3>
    <h3 className="stem">{VotingAge(16)}</h3>
    <h3 className="stem faint">{vo16} <span style={{display: vo16===1 ? "none":"inline-block"}}>countries</span><span style={{display: vo16===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">17: </h3>
    <h3 className="stem">{VotingAge(17)}</h3>
    <h3 className="stem faint">{vo17} <span style={{display: vo17===1 ? "none":"inline-block"}}>countries</span><span style={{display: vo17===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">18: </h3>
    <h3 className="stem">{VotingAge(18)}</h3>
    <h3 className="stem faint">{vo18} <span style={{display: vo18===1 ? "none":"inline-block"}}>countries</span><span style={{display: vo18===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">19: </h3>
    <h3 className="stem">{VotingAge(19)}</h3>
    <h3 className="stem faint">{vo19} <span style={{display: vo19===1 ? "none":"inline-block"}}>countries</span><span style={{display: vo19===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">20: </h3>
    <h3 className="stem">{VotingAge(20)}</h3>
    <h3 className="stem faint">{vo20} <span style={{display: vo20===1 ? "none":"inline-block"}}>countries</span><span style={{display: vo20===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">21: </h3>
    <h3 className="stem">{VotingAge(21)}</h3>
    <h3 className="stem faint">{vo21} <span style={{display: vo21===1 ? "none":"inline-block"}}>countries</span><span style={{display: vo21===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <Container>
        <Row>
            <Col className="text-center">
            <br/>
            <img className="text-center" alt="Al Jazeera" width="200px" height="auto" src={universalsuffrage}/>
            </Col>
        </Row>
    </Container>

    <h2 id="suffrage" className="display-3 text-center">When could all citizens vote?</h2>
    <br/>
        <p>In 1893, New Zealand became the first country in the world to grant women the right to vote. By the 1950s, two-thirds of countries around the world had adopted universal suffrage, which allows all adult citizens equal rights to vote. The last European country to allow women to vote was Switzerland in 1971. In 1994, South Africa became the last African democracy to give equal voting rights to all following the end of apartheid. In Afghanistan, women gained and lost the right to vote several times. They have continuously held the right to vote since 2004.</p>
    <br/>
    <p className="smalltext">HOVER/TAP FOR COUNTRY NAMES</p>
    <br/>
    <h3 className="stem">1890s</h3>
    <h3 className="stem">{UniversalSuffrage(1890,1900)}</h3>
    <h3 className="stem faint">{us1} <span style={{display: us1===1 ? "none":"inline-block"}}>countries</span><span style={{display: us1===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1900s</h3>
    <h3 className="stem">{UniversalSuffrage(1900,1910)}</h3>
    <h3 className="stem faint">{us2} <span style={{display: us2===1 ? "none":"inline-block"}}>countries</span><span style={{display: us2===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1910s</h3>
    <h3 className="stem">{UniversalSuffrage(1910,1920)}</h3>
    <h3 className="stem faint">{us3} <span style={{display: us3===1 ? "none":"inline-block"}}>countries</span><span style={{display: us3===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1920s</h3>
    <h3 className="stem">{UniversalSuffrage(1920,1930)}</h3>
    <h3 className="stem faint">{us4} <span style={{display: us4===1 ? "none":"inline-block"}}>countries</span><span style={{display: us4===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1930s</h3>
    <h3 className="stem">{UniversalSuffrage(1930,1940)}</h3>
    <h3 className="stem faint">{us5} <span style={{display: us5===1 ? "none":"inline-block"}}>countries</span><span style={{display: us5===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1940s</h3>
    <h3 className="stem">{UniversalSuffrage(1940,1950)}</h3>
    <h3 className="stem faint">{us6} <span style={{display: us6===1 ? "none":"inline-block"}}>countries</span><span style={{display: us6===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1950s</h3>
    <h3 className="stem">{UniversalSuffrage(1950,1960)}</h3>
    <h3 className="stem faint">{us7} <span style={{display: us7===1 ? "none":"inline-block"}}>countries</span><span style={{display: us7===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1960s</h3>
    <h3 className="stem">{UniversalSuffrage(1960,1970)}</h3>
    <h3 className="stem faint">{us8} <span style={{display: us8===1 ? "none":"inline-block"}}>countries</span><span style={{display: us8===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1970s</h3>
    <h3 className="stem">{UniversalSuffrage(1970,1980)}</h3>
    <h3 className="stem faint">{us9} <span style={{display: us9===1 ? "none":"inline-block"}}>countries</span><span style={{display: us9===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1980s</h3>
    <h3 className="stem">{UniversalSuffrage(1980,1990)}</h3>
    <h3 className="stem faint">{us10} <span style={{display: us10===1 ? "none":"inline-block"}}>countries</span><span style={{display: us10===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1990s</h3>
    <h3 className="stem">{UniversalSuffrage(1990,2000)}</h3>
    <h3 className="stem faint">{us11} <span style={{display: us11===1 ? "none":"inline-block"}}>countries</span><span style={{display: us11===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">2000s</h3>
    <h3 className="stem">{UniversalSuffrage(2000,2010)}</h3>
    <h3 className="stem faint">{us12} <span style={{display: us12===1 ? "none":"inline-block"}}>countries</span><span style={{display: us12===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>

    <Container>
        <Row>
            <Col className="text-center">
            <br/>
            <img className="text-center" alt="Al Jazeera" width="200px" height="auto" src={howoften}/>
            </Col>
        </Row>
    </Container>
    <h2 className="display-3 text-center">How often are elections held?</h2>
    <br/>
        <p>Most countries hold elections every 4-5 years. The country with the most frequently held elections is San Marino, where a leader from one of two alternating parties is elected every six months.</p>
    <br/>
    <p className="smalltext">HOVER/TAP FOR COUNTRY NAMES</p>
    <br/>
    <h3 className="stem">Every year:</h3>
    <h3 className="stem">{LeadershipTerm(0,1)}</h3>
    <h3 className="stem faint">{lt11} <span style={{display: lt11===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt11===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    {/* <h3 className="stem">Every 2 years:</h3>
    <h3 className="stem">{LeadershipTerm(1,2)}</h3>
    <h3 className="stem faint">{lt12} <span style={{display: lt12===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt12===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/> */}
    <h3 className="stem">Every 3 years:</h3>
    <h3 className="stem">{LeadershipTerm(2,3)}</h3>
    <h3 className="stem faint">{lt23} <span style={{display: lt23===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt23===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">Every 4 years:</h3>
    <h3 className="stem">{LeadershipTerm(3,4)}</h3>
    <h3 className="stem faint">{lt34} <span style={{display: lt34===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt34===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">Every 5 years:</h3>
    <h3 className="stem">{LeadershipTerm(4,5)}</h3>
    <h3 className="stem faint">{lt45} <span style={{display: lt45===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt45===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">Every 6 years:</h3>
    <h3 className="stem">{LeadershipTerm(5,6)}</h3>
    <h3 className="stem faint">{lt56} <span style={{display: lt56===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt56===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">Every 7 years:</h3>
    <h3 className="stem">{LeadershipTerm(6,7)}</h3>
    <h3 className="stem faint">{lt67} <span style={{display: lt67===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt67===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">No set period:</h3>
    <h3 className="stem">{LeadershipTerm(7,1000)}</h3>
    <h3 className="stem faint">{lt7100} <span style={{display: lt7100===1 ? "none":"inline-block"}}>countries</span><span style={{display: lt7100===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <br/>
    <Container>
        <Row>
            <Col className="text-center">
            <br/>
            <img className="text-center" alt="Al Jazeera" width="200px" height="auto" src={howoften}/>
            </Col>
        </Row>
    </Container>
    <h2 className="display-3 text-center">How many terms can each leader serve?</h2>
    <br/>
        <p>Most leaders can either serve one or two terms in office. It’s not uncommon, however, for a country’s leader to have an unspecified term limit. In some countries, such as the United Kingdom and New Zealand, heads of government serve until they resign or lose majority support of parliament. Other countries without term limits, like Venezuela, let voters petition for a recall election after a certain period of time.</p>
    <br/>
    <p className="smalltext">HOVER/TAP FOR COUNTRY NAMES</p>
    <br/>
    <h3 className="stem">1 term</h3>
    <h3 className="stem">{MaxLeadershipTerm(0,1)}</h3>
    <h3 className="stem faint">{mlt12} <span style={{display: mlt12===1 ? "none":"inline-block"}}>countries</span><span style={{display: mlt12===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">2 terms</h3>
    <h3 className="stem">{MaxLeadershipTerm(1,2)}</h3>
    <h3 className="stem faint">{mlt23} <span style={{display: mlt23===1 ? "none":"inline-block"}}>countries</span><span style={{display: mlt23===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    {/* <h3 className="stem">3 terms</h3>
    <h3 className="stem">{MaxLeadershipTerm(3,4)}</h3>
    <h3 className="stem faint">{mlt34} <span style={{display: mlt34===1 ? "none":"inline-block"}}>countries</span><span style={{display: mlt34===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/> */}
    <h3 className="stem">Unlimited</h3>
    <h3 className="stem">{MaxLeadershipTerm(10,1000)}</h3>
    <h3 className="stem faint">{mlt10100} <span style={{display: mlt10100===1 ? "none":"inline-block"}}>countries</span><span style={{display: mlt10100===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <br/>
    <Container>
        <Row>
            <Col className="text-center">
            <br/>
            <img className="text-center" alt="Al Jazeera" width="200px" height="auto" src={currentleader}/>
            </Col>
        </Row>
    </Container>
    
    <h2 className="display-3 text-center">How long has the current leader been in power?</h2>
    <br/>
        <p>Cameroon’s President Paul Biya is the world’s longest-serving, non-royal leader. He’s been in power for 44 years. He’s followed by Equatorial Guinea’s Teodoro Obiang Nguema Mbasogo - 40 years - and Cambodia’s Hun Sen - 34 years.</p>
    <br/>
    <p className="smalltext">HOVER/TAP FOR COUNTRY NAMES</p>
    <br/>
    <h3 className="stem">Less than 1 year</h3>
    <h3 className="stem">{CurrentLeadership(0,1)}</h3>
    <h3 className="stem faint">{cl01} <span style={{display: cl01===1 ? "none":"inline-block"}}>countries</span><span style={{display: cl01===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">1-4 years</h3>
    <h3 className="stem">{CurrentLeadership(1,4)}</h3>
    <h3 className="stem faint">{cl14} <span style={{display: cl14===1 ? "none":"inline-block"}}>countries</span><span style={{display: cl14===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">5-9 years</h3>
    <h3 className="stem">{CurrentLeadership(5,9)}</h3>
    <h3 className="stem faint">{cl59} <span style={{display: cl59===1 ? "none":"inline-block"}}>countries</span><span style={{display: cl59===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">10-19 years</h3>
    <h3 className="stem">{CurrentLeadership(10,19)}</h3>
    <h3 className="stem faint">{cl1019} <span style={{display: cl1019===1 ? "none":"inline-block"}}>countries</span><span style={{display: cl1019===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">20-30 years</h3>
    <h3 className="stem">{CurrentLeadership(20,30)}</h3>
    <h3 className="stem faint">{cl2030} <span style={{display: cl2030===1 ? "none":"inline-block"}}>countries</span><span style={{display: cl2030===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">More than 30 years</h3>
    <h3 className="stem">{CurrentLeadership(30,100)}</h3>
    <h3 className="stem faint">{cl30100} <span style={{display: cl30100===1 ? "none":"inline-block"}}>countries</span><span style={{display: cl30100===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <br/>
    <Container>
        <Row>
            <Col className="text-center">
            <br/>
            <img className="text-center" alt="Al Jazeera" width="200px" height="auto" src={prisoners}/>
            </Col>
        </Row>
    </Container>
    
    <h2 id="prisonersvote" className="display-3 text-center">In which countries can prisoners vote?</h2>
    <br/>
        <p>Countries have different laws pertaining to whether or not prisoners can vote. Roughly a third of countries around the world allow prisoners to vote. Another one-third allow some prisoners to vote, usually based on the type of prison sentence or on local laws. The remaining one-third of countries do not allow prisoners to vote altogether. </p>
    <br/>
    <p className="smalltext">HOVER/TAP FOR COUNTRY NAMES</p>
    <br/>
    <h3 className="stem">All prisioners can vote:</h3>
    <h3 className="stem">{PrisonersVote("YES")}</h3>
    <h3 className="stem faint">{pv1} <span style={{display: pv1===1 ? "none":"inline-block"}}>countries</span><span style={{display: pv1===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">Some prisioners can vote:</h3>
    <h3 className="stem">{PrisonersVote("PARTIAL")}</h3>
    <h3 className="stem faint">{pv2} <span style={{display: pv2===1 ? "none":"inline-block"}}>countries</span><span style={{display: pv2===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
    <h3 className="stem">No prisioners can vote:</h3>
    <h3 className="stem">{PrisonersVote("NO")}</h3>
    <h3 className="stem faint">{pv3} <span style={{display: pv3===1 ? "none":"inline-block"}}>countries</span><span style={{display: pv3===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>

    {/* <Container>
        <Row>
            <Col className="text-center">
            <br/>
            <img className="text-center" alt="Al Jazeera" width="200px" height="auto" src={electronicvoting}/>
            </Col>
        </Row>
    </Container> */}

    {/* <h2 id="electronicvoting" className="display-3 text-center">Which countries use electronic voting?</h2>
    <br/>
        <p>Electronic voting machines are still only used by a handful of countries for national elections.</p>
    <br/>
    <p className="smalltext">HOVER/TAP FOR COUNTRY NAMES</p>
    <br/>

    <h3 className="stem">Complete electronic voting:</h3>
    <h3 className="stem">{ElectronicVoting("YES")}</h3>
    <h3 className="stem faint">{ev1} <span style={{display: ev1===1 ? "none":"inline-block"}}>countries</span><span style={{display: ev1===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/>
     <h3 className="stem">Partial electronic voting:</h3>
    <h3 className="stem">{ElectronicVoting("PARTIAL")}</h3>
    <h3 className="stem faint">{ev2} <span style={{display: ev2===1 ? "none":"inline-block"}}>countries</span><span style={{display: ev2===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/> */}
    {/*<h3 className="stem">No electronig voting:</h3>
    <h3 className="stem">{ElectronicVoting("NO")}</h3>
    <h3 className="stem faint">{ev3} <span style={{display: ev3===1 ? "none":"inline-block"}}>countries</span><span style={{display: ev3===1 ? "inline-block":"none"}}>country</span></h3>
    <hr/> */}
    
    
                    </Col>
                </Row>
            </Container>
            </div>
        )
    }
               
    }




export default IntroSelect